const flatList = [];

function transFlatList(nodes) {
  if (Array.isArray(nodes)) {
    nodes.forEach((item) => {
      const { id, name, children } = item;

      flatList.push({
        id,
        name,
      });

      transFlatList(children);
    });
  }
}

export function getTree(params) {
  const { isFirstFetch } = params;
  let defer;

  if (isFirstFetch) {
    defer = this.$ajax.gatewayPost('/basic/common/category/getTree', {
      bizType: 'basicCorpManage',
    }).then((data) => {
      const { nodes } = data.data || {};

      transFlatList(nodes);
      return {
        allTreeData: nodes || [],
      };
    });
  } else {
    defer = Promise.resolve({ list: [] });
  }

  return defer;
}

export function searchTree({ keywords }) {
  const showList = flatList.filter((item) => {
    const rex = new RegExp(`${keywords}`);
    return rex.test(item.name);
  });

  return Promise.resolve({
    list: showList,
    total: showList.length,
  });
}

